import { defineMessages } from 'react-intl-next';

export const messages: {
	buildDynamicCards: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noDynamicCards: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	noDynamicCards: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.error-states.no-dynamic-cards.header',
		defaultMessage: 'No dynamic cards yet',
		description: 'Header message shown when there are no dynamic cards to display',
	},
	buildDynamicCards: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.build-dynamic-cards',
		defaultMessage: 'Build dynamic cards',
		description:
			'Action button message for building dynamic cards, when clicked, shows a modal to build dynamic cards with new filters',
	},
});
